import React, { useState } from "react";
import BlocksTab from "./tabs/BlocksTab";
import ConnectionsTab from "./tabs/ConnectionsTab";

const PlacementTab = () => {
  const [subTab, setSubTab] = useState("BLOCKS");

  return (
    <div>
      <div style={{ display: "flex", borderBottom: "1px solid #444", backgroundColor: "#2c2c2c" }}>
        {["BLOCKS", "CONNECTIONS"].map((tab) => (
          <div
            key={tab}
            onClick={() => setSubTab(tab)}
            style={{
              padding: "10px 12px",
              cursor: "pointer",
              fontSize: "12px",
              fontWeight: subTab === tab ? "bold" : "normal",
              color: subTab === tab ? "#00bcd4" : "#ccc",
              borderBottom: subTab === tab ? "3px solid #00bcd4" : "3px solid transparent",
              whiteSpace: "nowrap",
              flex: "none",
            }}
          >
            {tab}
          </div>
        ))}
      </div>

      <div style={{ paddingTop: "10px" }}>
        {subTab === "BLOCKS" && <BlocksTab />}
        {subTab === "CONNECTIONS" && <ConnectionsTab />}
      </div>
    </div>
  );
};

export default PlacementTab;
